// frontend/src/config/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBCqyrQdrbr7bxOcKEbnUdm5_xwB0FzR20",
  authDomain: "hope-sacco-42375.firebaseapp.com",
  projectId: "hope-sacco-42375",
  storageBucket: "hope-sacco-42375.firebasestorage.app",
  messagingSenderId: "530046422485",
  appId: "1:530046422485:web:474ecd06af60f994e2415c",
  measurementId: "G-58VPRWKDSF"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;